import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';

import { TabLeftPanel, BurgerBtn } from 'react-inv-forms';

import { RootState } from '../../../../redux/reducers';
import { studentFinderActionsInterfaces, studentFinderActionsSelectors } from '../../../../redux/staticViews/studentFinder';

import withMobileAsideHandler, { WithMobileAsideHandlerProps } from '../../../../hoc/withMobileAsideHandler';

import MobileAside from '../../../UI/MobileAside';
import { AboveTableContainer } from '../../../../styles/tabContainers';
import { StudentImage } from './StudentInfo.style';

type MapStateToProps = ReturnType<typeof mapStateToProps>;

type StudentDetailsProps = StaticViewComponent & MapStateToProps & WithMobileAsideHandlerProps;

/**
 * Widok wyświetlający informację szczegółowe o wybranym wcześniej studencie - z wyszukiwarki.
 *
 */
// export dodany w celu wyświetlenia komentarza w dokumentacji, ponieważ opakowane funkcje mają problem z wyświetlaniem
export const StudentDetails = ({
  singleStudent,
  showAsideButton,
  openedMobileAside,
  toggleAside,
}: StudentDetailsProps): JSX.Element | null => {
  const { t } = useTranslation();
  const [photoBase, setPhotoBase] = useState('');

  useEffect(() => {
    if (!singleStudent) {
      return;
    }

    setPhotoBase(`data:image/svg;base64, ${singleStudent?.studentZdjecie}`);
  }, [singleStudent]);

  return !singleStudent ? null : showAsideButton ? (
    <React.Fragment>
      <MobileAside opened={openedMobileAside}>
        <StudentImage src={photoBase} alt='studentPhoto' />
        <TabLeftPanel>
          <React.Fragment>
            <section>
              <h4>{t('STUDENT_FILTER_IMIE_NAZWISKO')}</h4>
              <strong>
                {singleStudent?.studentImie} {singleStudent?.studentNazwisko}
              </strong>
            </section>
            <section>
              <h4>{t('STUDENT_FILTER_ALBUM')}</h4>
              <strong>{singleStudent?.studentAlbum}</strong>
            </section>
            <section>
              <h4>{t('STUDENT_FILTER_WYDZIAL')}</h4>
              <strong>{singleStudent?.studentWydzial}</strong>
            </section>
          </React.Fragment>
        </TabLeftPanel>
        <TabLeftPanel>
          <React.Fragment>
            <section>
              <h4>{t('STUDENT_FILTER_KIERUNEK')}</h4>
              <strong>{singleStudent?.kierunekNazwa}</strong>
            </section>
            <section>
              <h4>{t('STUDENT_FILTER_RODZAJ')}</h4>
              <strong>{singleStudent?.rodzajStudiow}</strong>
            </section>
            <section>
              <h4>{t('STUDENT_FILTER_GRUPA_DZIEKANSKA')}</h4>
              <strong>{singleStudent?.grupaDziekanska}</strong>
            </section>
          </React.Fragment>
        </TabLeftPanel>
      </MobileAside>
      <AboveTableContainer>
        <BurgerBtn onClick={toggleAside} opened={openedMobileAside} />
      </AboveTableContainer>
    </React.Fragment>
  ) : (
    <TabLeftPanel>
      <React.Fragment>
        <StudentImage src={photoBase} alt='studentPhoto' />
        <section>
          <h4>{t('STUDENT_FILTER_IMIE_NAZWISKO')}</h4>
          <strong>
            {singleStudent?.studentImie} {singleStudent?.studentNazwisko}
          </strong>
        </section>
        <section>
          <h4>{t('STUDENT_FILTER_ALBUM')}</h4>
          <strong>{singleStudent?.studentAlbum}</strong>
        </section>
        <section>
          <h4>{t('STUDENT_FILTER_WYDZIAL')}</h4>
          <strong>{singleStudent?.studentWydzial}</strong>
        </section>
        <section>
          <h4>{t('STUDENT_FILTER_KIERUNEK')}</h4>
          <strong>{singleStudent?.kierunekNazwa}</strong>
        </section>
        <section>
          <h4>{t('STUDENT_FILTER_RODZAJ')}</h4>
          <strong>{singleStudent?.rodzajStudiow}</strong>
        </section>
        <section>
          <h4>{t('STUDENT_FILTER_GRUPA_DZIEKANSKA')}</h4>
          <strong>{singleStudent?.grupaDziekanska}</strong>
        </section>
      </React.Fragment>
    </TabLeftPanel>
  );
};

// użycie hoca zamiast hooka spowodowane chęcią zachowania jednolitości (i tak by trzeba było opakować inne elementy logiki)
const mapStateToProps = (state: RootState): Pick<studentFinderActionsInterfaces.StudentFinderState, 'singleStudent'> => ({
  singleStudent: studentFinderActionsSelectors.getSingleStudent(state),
});

export default compose(connect(mapStateToProps, null), withMobileAsideHandler)(StudentDetails) as React.ComponentType<any>;
